import React, { useEffect } from "react";
import useSingleOrganization from "../../../hooks/useSingleOrganization";
import { Organization } from "../../../types/organization.types";
import { dateConverter } from "../../../../../utils/dateConverter";
import { useUserAdminExtend } from "../../../../user/hooks/useAdminUser";
import { statusConverterOrg } from "../../OrganizationList/OrganizationList/OrganizationListView/OrganizationListView";
import { limitString } from "../../../../../utils/string.utils";

export type OrganizationInfoObject = Organization & {
  organization_nb_users: number;
};

export interface OrganizationInfoProps {
  info: keyof OrganizationInfoObject;
  id?: string;
  styled?: boolean;
  emptyText?: string;
  limitText?: number;
  renderComponent?: (config: {
    labelRender: React.ReactNode;
    goTo: () => void;
  }) => JSX.Element;
}
export default function OrganizationInfo({
  info,
  id,
  emptyText,
  styled,
  limitText,
}: OrganizationInfoProps) {
  const {
    singleOrganizationQuery: { isLoading, isError, data },
  } = useSingleOrganization(id);
  const [organizationId, setOrganizationId] = React.useState<
    string | undefined
  >(undefined);
  useEffect(() => {
    if (data?.organization_id) {
      setOrganizationId(data?.organization_id);
    }
  }, [data]);
  const attributOrg = info as keyof Organization;
  if (isLoading) return <>...</>;
  if (isError) return <>{emptyText ? emptyText : ""}</>;

  if (info === "organization_nb_users" && organizationId) {
    return (
      <NbUserOrganization
        organizationId={organizationId}
        emptyText={emptyText}
      />
    );
  }

  if (info === "organization_status" && styled && data?.organization_status) {
    return statusConverterOrg(data?.organization_status);
  }

  const convertValue = (info: keyof OrganizationInfoObject, value: any) => {
    switch (info) {
      case "organization_create_at":
        return dateConverter(value);
      case "organization_update_at":
        return dateConverter(value, { withTime: true });

      default:
        return value;
    }
  };

  return (
    <>
      {data?.[attributOrg]
        ? limitString(convertValue(info, data?.[attributOrg]), limitText)
        : emptyText
        ? emptyText
        : ""}
    </>
  );
}

const NbUserOrganization = ({
  organizationId,
  emptyText,
}: {
  organizationId: string;
  emptyText?: string;
}) => {
  const { userAdminExtendListQuery:getAllAdminUserQuery } = useUserAdminExtend({
    pageSize: 1,
    preFilter: { organization_id: `=${organizationId}` },
    
  });
  if (getAllAdminUserQuery.isLoading) return <>...</>;
  if (getAllAdminUserQuery.isError) return <>{emptyText || "-"}</>;

  return <>{getAllAdminUserQuery.data?.pagination.total_count}</>;
};
